// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import Main from './Routes/Routes';

function App() {
  return (
    <Router>
      <Main />
    </Router>
  );
}

export default App;
